
import { Component, Vue, Watch } from "vue-property-decorator";
import { IDefaultShippingOrderModel } from "@/api/types";
import Pagination from "@/components/Pagination/index.vue";
import { searchCustomer } from "@/api/customer";
import { getSuppliersList } from "@/api/inquiry";
import { getList, downloadList, remark } from "@/api/purchase-order";
import { putSupplierDeduction } from "@/api/credit-note";
import { getAmounte } from "@/api/purchase-order";

import {
  getSalesmanList,
  auditHold,
  removeQuotation,
  generatePI,
  auditPass,
} from "@/api/inquiry";
import {
  getPiList,
  updatePiRemark,
  getPiDeliveryStatus,
  getPiCustomerShipmentStatus,
  confirmOrder,
  invalidPi,
  uncancelPi,
  downloadPiDetail,
} from "@/api/proforma";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import { deepClone } from "@/utils/deepClone";
import { INVOICE_STATUS } from "@/constant";
import { getClaimReason, getDeductionMethod } from "@/api/credit-note";
import { getUsersByJobPosition } from "@/api/users";
import {UserModule} from "@/store/modules/user";

@Component({
  name: "supplierOrderManagement",
  components: {
    Pagination,
    Create: () => import("./components/Create.vue"),
    Money: () => import("./components/Money.vue"),
  },
})
export default class extends Vue {
  private isShowMore = false;
  private isShowMore2 = false;
  private listLoading = true;
  private showCreate = false;
  private showMoney = false;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [{}] as any[],
  };
  public listParam = {
    supplier: null,
    purchase: null,
    hqProductName: null,
    lastOrderStartTime: null,
    lastOrderEndTime: null,
    sort: 0,
    status: 0,
    time: [],
  };
  private showCreateSupplierDeduction = false;
  private supplierList = [
    {
      label: "供应商",
      prop: "supplierId",
      key: "supplierId",
      type: "select",
      placeholder: "请选择供应商",
      clearable: true,
      rules: {
        required: true,
        message: "请选择供应商",
        trigger: "change",
      },
      remote_method: this.getSuppliersList,
      remote: true,
      options: [],
      labelKey: "abbreviation",
      valueKey: "id",
    },
    {
      label: "扣款类型",
      prop: "claimReason",
      key: "claimReason",
      type: "cascader",
      options: [],
      placeholder: "请选择扣款类型",
      clearable: true,
      rules: {
        required: true,
        message: "请选择扣款类型",
        trigger: "change",
      },
    },
    {
      label: "交易公司",
      prop: "company",
      key: "company",
      type: "select",
      labelKey: "desc",
      valueKey: "name",
      options: [
        {
          desc: "华强",
          name: "HQ",
        },
        {
          desc: "嘉锐",
          name: "JR",
        },
      ],
      placeholder: "请选择交易公司",
      clearable: true,
      rules: {
        required: true,
        message: "请选择交易公司",
        trigger: "change",
      },
    },
    {
      label: "扣款金额",
      prop: "claimAmount",
      key: "claimAmount",
      type: "inputNumber",
      precision: 2,
      placeholder: "请输入扣款金额",
      clearable: true,
      rules: {
        required: true,
        message: "请输入扣款金额",
        trigger: "change",
      },
    },
    {
      label: "协议号码",
      prop: "protocolNumber",
      key: "protocolNumber",
      type: "input",
      placeholder: "请输入协议号码",
      clearable: true,
    },
    {
      label: "对应开票金额",
      prop: "invoicingAmount",
      key: "invoicingAmount",
      type: "input",
      placeholder: "请输入对应开票金额",
      clearable: true,
    },
    {
      label: "扣款比例",
      prop: "deductionRatio",
      key: "deductionRatio",
      type: "input",
      placeholder: "请输入扣款比例",
      clearable: true,
      maxlength: 10,
      unit: "%",
    },
    {
      label: "签约日期",
      prop: "timeOfIssue",
      key: "timeOfIssue",
      type: "datetime",
      format: "yyyy-MM-dd hh:mm:ss",
      placeholder: "请选择签约日期",
      clearable: true,
    },
    {
      label: "抵扣方式",
      prop: "deductionMethod",
      key: "deductionMethod",
      type: "select",
      options: [],
      placeholder: "请选择抵扣方式",
      clearable: true,
      labelKey: "desc",
      valueKey: "name",
      rules: {
        required: true,
        message: "请选择抵扣方式",
        trigger: "change",
      },
    },
    {
      label: "扣款说明",
      prop: "remark",
      key: "remark",
      type: "textarea",
      placeholder: "请输入扣款说明",
      clearable: true,
    },
  ];
  private supplierForm = {
    supplierId: "",
    claimReason: "",
    company: "",
    claimAmount: 0,
    protocolNumber: "",
    invoicingAmount: "",
    deductionRatio: "",
    timeOfIssue: null,
    deductionMethod: "",
    remark: "",
  };
  public searchForm = [
    {
      label: "供应商",
      prop: "supplier",
      key: "supplier",
      type: "select",
      value: "",
      placeholder: "",
      remote_method: this.getSuppliersList,
      remote: true,
      clearable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" },
    },
    {
      label: "采购员",
      prop: "purchase",
      key: "purchase",
      type: "select",
      value: "",
      options: [],
      placeholder: "请输入采购员",
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      type: "input",
      value: "",
      placeholder: "请输入华强品名",
    },
    {
      label: "最后下单时间",
      prop: "time",
      key: "time",
      type: "dateTimePickerOne",
      value: "",
      placeholder: "",
    },
    {
      label: "排序方式",
      prop: "sort",
      key: "sort",
      type: "select",
      value: 0,
      placeholder: "全部",
      options: [
        {
          name: "正序",
          id: 0,
        },
        {
          name: "倒序",
          id: 1,
        },
      ],
    },
    {
      label: "单据状态",
      prop: "status",
      key: "status",
      type: "select",
      value: 0,
      placeholder: "全部",
      options: INVOICE_STATUS,
    },
  ];
  public tableCol = [
    {
      label: "供应商编号",
      prop: "code",
      key: "code",
      show: true,
      disabled: false,
      fixed: true,
    },
    {
      label: "供应商简称",
      prop: "abbreviation",
      key: "abbreviation",
      show: true,
      disabled: false,
      fixed: true,
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false,
    },
    {
      label: "采购员",
      prop: "purchase",
      key: "purchase",
      show: true,
      disabled: false,
    },
    {
      label: "未抵扣索赔",
      prop: "unDeductedClaim",
      key: "unDeductedClaim",
      show: true,
      disabled: false,
    },
    {
      label: "预定抵扣",
      prop: "bookingDeduction",
      key: "bookingDeduction",
      show: true,
      disabled: false,
    },
    {
      label: "已核销单据数",
      prop: "writtenOff",
      key: "writtenOff",
      show: true,
      disabled: false,
    },
    {
      label: "已完成单据数",
      prop: "completed",
      key: "completed",
      show: true,
      disabled: false,
    },
    {
      label: "交易中单据数",
      prop: "inTransaction",
      key: "inTransaction",
      show: true,
      disabled: false,
    },
    {
      label: "最后下单时间",
      prop: "lastOrderTime",
      key: "lastOrderTime",
      show: true,
      disabled: false,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "remark",
      show: true,
      disabled: false,
      length: 255,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "交易金额",
          code: ["transactionAmount"],
          click: "handleEdit",
        },
        {
          name: "管理采购订单",
          code: "",
          click: "handleOrderManage",
        },
      ],
      show: true,
      disabled: false,
      width: 300,
    },
  ] as any;

  created() {
    this.init();
  }

  activated() {
    this.init();
  }

  private init() {
    this.searchCustomer();
    this.getPiCustomerShipmentStatus();
    this.getPiDeliveryStatus();
    this.getList();
    this.getClaimReason();
    this.getDeductionMethod();
    this.initSellerList();
  }

  private async getSuppliersList(name = "") {
    const res: any = await this.getSuppliers(name);
    this.searchForm[0].options = res;
    this.supplierList[0].options = res;
  }

  private async getClaimReason() {
    const res: any = await getClaimReason();
    this.supplierList[1].options = res;
  }

  private async getDeductionMethod() {
    const res: any = await getDeductionMethod();
    this.supplierList[8].options = res;
  }

  private async getSuppliers(name = "") {
    const res: any = await getSuppliersList({ abbreviation: name });
    return res;
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = false;
    const { total, list }: any = await getList(params);
    this.table.total = +total;
    this.table.list = list;
    this.loading = false;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  private async showCreateSupplierDeductionFun(): Promise<void> {
    (this.$refs.ruleForm as any).$refs.ruleForm.validate(
      async (valid: boolean) => {
        if (valid) {
          try {
            if (this.supplierForm.claimReason.length > 0) {
              // this.supplierForm.claimReason =
              //   this.supplierForm.claimReason[
              //     this.supplierForm.claimReason.length - 1
              //   ];
              await putSupplierDeduction({...this.supplierForm,claimReason:this.supplierForm.claimReason[
                  this.supplierForm.claimReason.length - 1
                ]}).then(res => {
                this.$notify({
                  title: "成功",
                  message: "生成成功",
                  type: "success",
                  duration: 2000,
                });
                this.showCreateSupplierDeduction = false;
              }).catch(err => {
                console.log(err);
              });
            }
          } catch (error) {
            console.error(error);
          }
        }
      }
    );
  }

  // 导出excel
  private isExporting = false;

  // 导出
  private async handleExport() {
    await downloadList(this.listParam);
  }

  // 创建供应商扣款
  public handleCreate() {
    this.showCreateSupplierDeduction = true;
  }

  private handleSuccess() {
    this.showCreate = false;
    this.showMoney = false;
    this.selectedRows = [];
    (this.$refs.table as any).$refs.table.clearSelection();
    this.getList();
  }

  //  删除
  public async handleDelete(scope) {
    await removeQuotation({
      detailId: scope.row.approvalRecordId,
    });
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 审批通过
  public async handleAuditPass(scope) {
    this.$confirm("确定审批通过吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await auditPass(scope.row.approvalRecordId);
        this.$notify({
          title: "成功",
          message: "审批通过",
          type: "success",
          duration: 2000,
        });
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private handlePI(scope) {
    this.$alert(scope.row.approvalRecordId, "PI号码", {
      confirmButtonText: "复制",
      callback: () => {
        this.h5Copy(scope.row.approvalRecordId);
      },
    });
  }

  // 填写备注
  public async handleRemark(item) {
    try {
      await remark(item.supplierId, {
        remark: item.remark,
      });
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      await this.getList();
    } catch (e) {
      await this.getList();
    }
  }

  private h5Copy(content) {
    if (!document.queryCommandSupported("copy")) {
      // 不支持
      return false;
    }
    let textarea = document.createElement("textarea") as any;
    textarea.value = content;
    textarea.readOnly = "readOnly";
    document.body.appendChild(textarea);
    textarea.select(); // 选择对象
    textarea.setSelectionRange(0, content.length); // 核心
    let result = document.execCommand("copy"); // 执行浏览器复制命令
    textarea.remove();
    this.$notify({
      title: "成功",
      message: "复制成功",
      type: "success",
      duration: 2000,
    });
    return result;
  }

  private async searchCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    // this.searchForm[1].options = res;
  }

  private async getPiCustomerShipmentStatus() {
    const res: any = await getPiCustomerShipmentStatus();
    res.forEach((item) => {
      item.id = item.name;
      item.name = item.desc;
    });
    this.searchForm[7].options = res;
    this.tableCol.find((item) => item.key === "shipmentStatus").typeList = res;
  }

  private async getPiDeliveryStatus() {
    const res: any = await getPiDeliveryStatus();
    res.forEach((item) => {
      item.id = item.name;
      item.name = item.desc;
    });
    this.searchForm[6].options = res;
    this.tableCol.find((item) => item.key === "status").typeList = res;
  }

  public querySearch(data) {
    const params = Object.assign({}, data);
    const { time, ...rest } = params;
    if (time && time.length) {
      rest.lastOrderStartTime = time[0];
      rest.lastOrderEndTime = time[1];
    }
    this.listParam = rest;
    this.table.pageNumber = 1;
    this.getList();
  }

  private handleCustomer() {
    // empty
  }

  private linkClick(scope) {
    this.$router.push(`/PIDetails?id=${scope.row.id}`);
  }

  public selectedItem = {} as any;
  private moneyOBJ = {} as any;

  // 编辑
  public async handleEdit(scope) {
    this.selectedItem = scope.row;
    await getAmounte(scope.row.supplierId).then((res:any) => {
      this.moneyOBJ = res;
      this.showMoney = true;
    }).catch(err => {
      console.log(err);
    })
  }

  private handleOrderManage(scope) {
    let item = JSON.stringify(scope.row);
    if (item.indexOf("&") != -1) {
      item = item.replace("&", "replace");
    }
    this.$router.push(
      `/managePurchaseOrders?supplierId=${scope.row.supplierId}&item=${item}`
    );
  }


  private async initSellerList() {
    const res: any = await getUsersByJobPosition("purchaser");
    this.searchForm[1].options = res;
  }

  private async handleInvalidPi(scope) {
    this.$confirm("确定作废吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await invalidPi(scope.row.id)
          .then((res) => {
            this.confirmSuccess();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async handleUncancelPi(scope) {
    this.$confirm("确定取消作废吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await uncancelPi(scope.row.id)
          .then((res) => {
            this.confirmSuccess();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  // 挂起
  private async handleAuditHold(scope) {
    this.$prompt("请输入挂起原因", "挂起", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputType: "textarea",
    })
      .then(async ({ value }: any) => {
        if (!value) {
          this.$message.error("请输入挂起原因");
          return;
        }
        await auditHold({
          id: scope.row.approvalRecordId,
          remark: value,
        });
        this.getList();
      })
      .catch(() => {
        // empty
      });
  }

  private confirmSuccess() {
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 点击是否展示所有产品号码
  private showMore() {
    this.isShowMore = !this.isShowMore;
  }

  private showMore2() {
    this.isShowMore2 = !this.isShowMore2;
  }

  private selectedRows: IDefaultShippingOrderModel[] = [];

  private onSelectionChange(rows: IDefaultShippingOrderModel[]) {
    this.selectedRows = rows;
  }
}
